import React, { useState } from 'react';
import axios from 'axios';

const CourierProcessTab2 = () => {
  const [pincode, setPincode] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [district, setDistrict] = useState('');
  const [couriers, setCouriers] = useState([]);
  const [error, setError] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!pincode) {
      setError('Please enter a valid pincode.');
      return;
    }

    try {
      // Fetch pincode details
      const response = await axios.get(`https://astrovidhya.in/api/pincode-details/${pincode}`);
      setCity(response.data.city);
      setState(response.data.state);
      setDistrict(response.data.district);

      // Fetch couriers for the pincode
      const courierResponse = await axios.get(`https://astrovidhya.in/api/pincode-couriers/${pincode}`);
      setCouriers(courierResponse.data);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching data.');
    }
  };

  return (
    <div>
      <form onSubmit={handleSearch}>
        <input
          type="text"
          value={pincode}
          onChange={(e) => setPincode(e.target.value)}
          placeholder="Enter Pincode"
        />
        <button type="submit">Search</button>
      </form>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div>
        <p>City: {city}</p>
        <p>State: {state}</p>
        <p>District: {district}</p>
      </div>

      <table>
        <thead>
          <tr>
            <th>SNo</th>
            <th>Courier Name</th>
          </tr>
        </thead>
        <tbody>
          {couriers.map((courier, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{courier.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CourierProcessTab2;
